"use client";

import { HeaderNotificationBar, type HeaderNotificationBarItem } from "@dionatanbig2be/big2be-ui";
import { useAppSetting } from "../hooks/useBootstrap";
import { resolveWidgetLink } from "@/modules/widgets/lib/resolve-widget-link";
import type { HeaderNotificationItem, HeaderNotificationsContent } from "@/shared/settings";

/**
 * Mesma regra do nest-v4 (header-notifications.service.ts#resolveStatus):
 * status bruto 'disabled'/'paused' prevalece; senão calcula por data.
 */
function isActiveNow(item: HeaderNotificationItem): boolean {
    if (item.status === "disabled" || item.status === "paused") return false;
    const now = Date.now();
    if (item.startDate && new Date(item.startDate).getTime() > now) return false;
    if (item.endDate && new Date(item.endDate).getTime() < now) return false;
    return true;
}

function toBarItem(item: HeaderNotificationItem): HeaderNotificationBarItem {
    return {
        id: item.id,
        text: item.text,
        href: resolveWidgetLink(item.href, item.searchRules),
        backgroundColor: item.backgroundColor,
        textColor: item.textColor,
        accentColor: item.accentColor,
    };
}

/** Faixa de avisos do cabeçalho — content bruto de "header_notifications" resolvido no cliente. */
export function HeaderNotifications() {
    const content = useAppSetting<HeaderNotificationsContent>("header_notifications");

    if (!content?.enabled || !content.items?.length) return null;

    const items = content.items
        .filter(isActiveNow)
        .sort((a, b) => a.order - b.order || a.id - b.id)
        .map(toBarItem);

    return <HeaderNotificationBar items={items} />;
}
